module.exports = __webpack_public_path__ + "media/images/presta_busc/kinesiologo-af2bd9fe0da2323377c0adc9ea875b71.svg";